import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar showAnimations={false} />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6" style={{ color: '#000000' }}>Privacy Policy</h1>
      
      <section className="mb-8">
        <p className="mb-4" style={{ color: '#4b5563' }}>
          This privacy notice discloses the privacy practices for HFX LLC.
          HFX ("us", "we", or "our") operates the www.focuspips.com
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          This page informs you of our policies regarding the collection, use, and
          disclosure of personal data when you use our Service and the choices you have
          associated with that data.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We use your data to provide and improve the Service. By using the Service, you
          agree to the collection and use of information in accordance with this policy.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          This privacy notice applies solely to information collected by this web site. It
          will notify you of the following:
        </p>
        <ol className="list-decimal pl-8 mb-4">
          <li className="mb-2" style={{ color: '#4b5563' }}>
            What personally identifiable information is collected from you through the
            web site, how it is used and with whom it may be shared.
          </li>
          <li className="mb-2" style={{ color: '#4b5563' }}>
            What choices are available to you regarding the use of your data.
          </li>
          <li className="mb-2" style={{ color: '#4b5563' }}>
            The security procedures in place to protect the misuse of your information.
          </li>
          <li className="mb-2" style={{ color: '#4b5563' }}>
            How you can correct any inaccuracies in the information.
          </li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>Information Collection, Use, and Sharing</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We are the sole owners of the information collected on this site. We only have
          access to/collect information that you voluntarily give us when using the site.
          We will not sell or rent this information to anyone.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We use your information to provide the services of the site. We will not share
          your information with any third party outside of our organization, other than as
          necessary to fulfill your request. Specifically:
        </p>
        <ul className="list-disc pl-8 mb-4">
          <li className="mb-2" style={{ color: '#4b5563' }}>
            If you explicitly share a trade publicly, certain information about your trade will
            be made available on the site (you can see examples by looking at other shared
            trades on the site). If you do not wish this information to be public, please do
            not share trades.
          </li>
        </ul>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Unless you ask us not to, we may contact you via email in the future to tell you
          about specials, new products or services, or changes to this privacy policy.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We collect statistical information on web traffic using a third party web
          analytics service; this may use a cookie on your computer, but no user-
          identifiable information is ever shared with this third party other than "typical"
          web analytics such as IP address, browser, etc.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Specifically, we use <strong>Google Analytics 4</strong> (provided by Google LLC,
          1600 Amphitheatre Parkway, Mountain View, CA 94043, USA). Google Analytics uses
          cookies to analyze how visitors use the site. The information generated by these
          cookies (including your IP address, which is anonymized) is transmitted to and
          stored by Google on servers in the United States. We use Google's Consent Mode v2,
          meaning analytics cookies are only placed after you explicitly accept them. You can
          opt out at any time by refusing cookies via the banner on our site, or by installing
          the{' '}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4b5563', textDecoration: 'underline' }}
          >
            Google Analytics opt-out browser add-on
          </a>
          . Google's privacy policy is available at{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4b5563', textDecoration: 'underline' }}
          >
            policies.google.com/privacy
          </a>
          .
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          In no event will your individual data be made available to anyone, nor will any
          personally identifiable information be made available or associated with any of
          the data.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>Your Access to and Control Over Information</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You may opt out of any future contacts from us at any time. You can do the
          following at any time by contacting us via email at support@focuspips.com
        </p>
        <ul className="list-disc pl-8 mb-4">
          <li className="mb-2" style={{ color: '#4b5563' }}>Have us delete any data we have about you.</li>
          <li className="mb-2" style={{ color: '#4b5563' }}>Express any concern you have about our use of your data.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>Security</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We take precautions to protect your information. When you submit sensitive
          information via the website, your information is protected both online and
          offline.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Wherever we collect sensitive information (such as your trade data), that
          information is encrypted and transmitted to us in a secure way.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          If you feel that we are not abiding by this privacy policy, please contact us
          immediately via email at <a href="mailto:support@focuspips.com" style={{ color: '#4b5563', textDecoration: 'underline' }}>support@focuspips.com</a>
        </p>
      </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};
